/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onGenerateReportPDFRequest = /* GraphQL */ `subscription OnGenerateReportPDFRequest($ID: ID!) {
  onGenerateReportPDFRequest(ID: $ID) {
    ID
    Status
    url
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnGenerateReportPDFRequestSubscriptionVariables,
  APITypes.OnGenerateReportPDFRequestSubscription
>;
